<template>
  <div id="pers-tab2-7" name="hres32e-tab2-tab7" class="content-pers-table">
    <hrms-table :columns="detail2Tab7Table"
                :data="detail"
                :maxRowspan="maxRowspanDetail6"
                :addInlineEventBool="true"
                :editInlineEventBool="true"
                :deleteInlineEventBool="true"
                :deleteInlineBtnDisp="false"
                :saveInlineBtnDisp="validateStaappr"
                :saveInlineEvent="callSave"
                :flgToggle="personalDataActive" />

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import detailTemplate from 'components/hres32e/detailTemplate'

export default {
  name: 'hres32e-tab2-tab7',
  data () {
    return {
      subTopic1: true,
      subTopic2: true
    }
  },
  methods: {
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            p_codempid: this.indexSelected.codempid,
            p_dtereq: this.indexSelected.dtereq,
            p_numseq: this.indexSelected.numseq,
            p_codempid_query: this.indexSelected.codempid
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postDetail2Tab7Save({ saveParams: dataRowsHasFlg, searchIndex: this.searchIndex, togglePage: this.togglePage, indexSelected: this.indexSelected })
        }
      })
    }
  },
  props: [ 'nowLang',
    'labels',
    'detail',
    'pcDisp',
    'togglePage',
    'toggleSubPage',
    'triggerSubButton',
    'deleteDocuments',
    'labelsButton',
    'dropdowns',
    'detail2Tab7Table',
    'postDetail2Tab7Save',
    'indexSelected',
    'searchIndex',
    'personalDataActive',
    'validateStaappr'
  ],
  components: {
    detailTemplate
  }
}

</script>



// WEBPACK FOOTER //
// tab2_7.vue?411517f8